<div
    class="d-flex w-100 condition-scorecard-widget"
    [class.align-items-start]="_collapsed"
>
    <cmps-container
        class="cmps-scorecard-widget--cmps-container"
        [collapsable]="false"
        (collapsedChange)="_collapsed = $event"
        variant="colored"
    >
        <cmps-container-header
            [separator]="false"
            class="text-center"
            [headerColour]="headerColour"
            [textColour]="headerTextColour"
        >
            {{ _widget.name }}
        </cmps-container-header>
        <cmps-container-content>
            <cmps-wait-status
                [srStatus]="'Loading ' + _widget.name"
                *ngIf="_isLoadingData | async"
            ></cmps-wait-status>
            <div
                class="no-data w-100 p-2"
                *ngIf="
                    !(_isLoadingData | async) &&
                    _compensationCondition?.length === 0
                "
            >
                {{ _i18n._711_NO_DATA_AVAILABLE | translate }}
            </div>
            <div
                class="w-100"
                *ngIf="
                    !(_isLoadingData | async) &&
                    _compensationCondition?.length !== 0
                "
            >
                <div class="table-responsive">
                    <table class="table table-bordered sc-widget-table">
                        <caption></caption>
                        <thead>
                            <tr>
                                <th
                                    scope="col"
                                    class="align-middle"
                                >
                                    {{
                                        _i18n._9301_COMPENSATION_DESCRIPTION
                                            | translate
                                    }}
                                </th>
                                <th
                                    scope="col"
                                    class="align-middle"
                                >
                                    {{
                                        _i18n._9302_COMPENSATION_CURRENT_VALUE
                                            | translate
                                    }}
                                </th>
                                <th
                                    scope="col"
                                    class="align-middle"
                                >
                                    {{
                                        _i18n._9303_COMPENSATION_IN_EFFECT
                                            | translate
                                    }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of _compensationCondition">
                                <td class="main text-left">
                                    {{ data.description | cmpsCompDesc: data }}
                                </td>
                                <td>
                                    {{ (data.value | number: '1.0-2') || '-' }}
                                </td>
                                <td>
                                    <sc-yesno-display
                                        [label]="
                                            (data.inEffect
                                                ? _i18n._9297_YES
                                                : _i18n._9298_NO
                                            ) | translate
                                        "
                                        [isPositive]="data.isPositive"
                                        [showIcon]="false"
                                        [useBoldFont]="true"
                                        [iconColour]="headerColour"
                                    ></sc-yesno-display>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </cmps-container-content>
    </cmps-container>
</div>
